import { PlanilhaStatus } from "@models/index";

const ROTULOS: Record<PlanilhaStatus, string> = {
  [PlanilhaStatus.PENDENTE]: "Pendente",
  [PlanilhaStatus.EM_ANDAMENTO]: "Em Andamento",
  [PlanilhaStatus.ENVIADO_WRIKE]: "Enviado para o Wrike",
  [PlanilhaStatus.FACITE_GERADA]: "FACITE Gerada",
  [PlanilhaStatus.CONCLUIDO]: "Concluído",
  [PlanilhaStatus.FINALIZADO]: "Finalizado",
  [PlanilhaStatus.CANCELADO]: "Cancelado",
};

/**
 * Ordem do seletor: a trilha do projeto, com o desvio (Cancelado) no fim.
 * É a mesma sequência que StatusPlanilha.Trilha usa na API para decidir se um
 * gatilho avança — manter as duas alinhadas evita seletor que sugere um
 * caminho e servidor que recusa outro.
 */
export const STATUS_PLANILHA_ORDEM: PlanilhaStatus[] = [
  PlanilhaStatus.PENDENTE,
  PlanilhaStatus.EM_ANDAMENTO,
  PlanilhaStatus.ENVIADO_WRIKE,
  PlanilhaStatus.FACITE_GERADA,
  PlanilhaStatus.CONCLUIDO,
  PlanilhaStatus.FINALIZADO,
  PlanilhaStatus.CANCELADO,
];

const SLUGS = new Set<string>(Object.values(PlanilhaStatus));

// Espelha StatusPlanilha.Legados da API: planilha gravada antes da migração
// para slug, ou resposta de um cliente desatualizado.
const LEGADOS: Record<string, PlanilhaStatus> = {
  pendente: PlanilhaStatus.PENDENTE,
  "em andamento": PlanilhaStatus.EM_ANDAMENTO,
  finalizado: PlanilhaStatus.FINALIZADO,
  concluído: PlanilhaStatus.CONCLUIDO,
  concluido: PlanilhaStatus.CONCLUIDO,
  cancelado: PlanilhaStatus.CANCELADO,
};

/**
 * Resolve qualquer valor vindo da API para um status conhecido. Cai em
 * "Em Andamento" no desconhecido: planilha com status órfão precisa continuar
 * visível e editável, não sumir da tela.
 */
export const normalizarStatusPlanilha = (
  status?: string | null,
): PlanilhaStatus => {
  if (!status) return PlanilhaStatus.EM_ANDAMENTO;

  const limpo = status.trim();
  if (SLUGS.has(limpo)) return limpo as PlanilhaStatus;

  return LEGADOS[limpo.toLowerCase()] ?? PlanilhaStatus.EM_ANDAMENTO;
};

export const rotuloStatusPlanilha = (status?: string | null): string =>
  ROTULOS[normalizarStatusPlanilha(status)];

/**
 * Classe da pílula. Deriva do slug já normalizado — antes o CSS recebia
 * `status-${status.toLowerCase()}` e "Em Andamento" virava `status-em andamento`,
 * que o navegador lê como duas classes e deixava a pílula sem cor nenhuma.
 */
export const classeStatusPlanilha = (status?: string | null): string =>
  `status-${normalizarStatusPlanilha(status)}`;
